import { PaymentLineItem } from "../../../Utilities";

export function calculateTotalAmount(payment: { paymentLineItems: Pick<PaymentLineItem, "amount">[] }) {
	let total = 0;
	for (let i = 0; i < payment.paymentLineItems.length; i++) {
		const lineItem = payment.paymentLineItems[i];
		total += lineItem.amount;
	}
	return total;
}
